import { render } from "./Planner.vue?vue&type=template&id=5b0f7c88"
import script from "./Planner.vue?vue&type=script&lang=js"
export * from "./Planner.vue?vue&type=script&lang=js"
script.render = render

export default script